<!-- bd-example-row and bd-example just for demo purposes -->
<div class="bd-example-row">
  <div class="bd-example">
    <div *ngFor="let item of items"></div>
  </div>
</div>
